/** Optional Tags field shared by manual and real-estate Account Details. */
export interface AccountFormTagFields {
  SelectedTagIds: number[];
}

/** De-duped finite tag ids from a form Tags field. */
export function uniqueFiniteTagIds(ids: readonly number[]): number[] {
  return [...new Set(ids.filter((id) => Number.isFinite(id)))];
}

export function readFormSelectedTagIds(
  isRealEstate: boolean,
  realEstateValues: AccountFormTagFields,
  accountValues: AccountFormTagFields,
): number[] {
  return uniqueFiniteTagIds(
    isRealEstate
      ? realEstateValues.SelectedTagIds
      : accountValues.SelectedTagIds,
  );
}
